module.exports = __webpack_public_path__ + "img/client-logo3.fe6ffb66.png";